import store from '../../store/store';
import type { FeatureOptions } from '../models/FeatureOptions';
/**
 * Open the assistant (if not already opened) and start the feature "product analysis question".
 */
export function startFeature(options: FeatureOptions): Promise<void> {
    return store.dispatch.featureState.startFeature(options);
}
